const colors = {
    primary: '#F8921D',
    black: '#000000',
    white: '#ffffff',
    secondary: '#1DD1AD',
    red: '#E43451'
}

export default colors;
